import { IonModal } from '@ionic/react';
import {
  MutableRefObject,
  ReactElement,
  createContext,
  useRef,
  useState,
} from 'react';
import { ChatMessage } from '../../api/graphql/generated';
import { ConversationModal } from './conversation-modal';

interface ConversationContext {
  updateMessage: (message: ChatMessage) => Promise<void>;
}

export const ConversationContext = createContext<
  ConversationContext | undefined
>(undefined);

interface ConversationModalProviderRenderProps {
  containerRef: MutableRefObject<HTMLElement | undefined>;
  createNew: () => void;
}

interface ConversationModalProviderProps {
  id: string;
  children: (renderProps: ConversationModalProviderRenderProps) => ReactElement;
}

const ConversationModalProvider = (
  props: ConversationModalProviderProps
): ReactElement => {
  const { id, children } = props;

  const [isOpen, setOpen] = useState<boolean>(false);
  const [selectedMessage, setSelectedMessage] = useState<ChatMessage>();
  const containerRef = useRef<HTMLElement>();

  const updateMessage = async (message: ChatMessage) => {
    setSelectedMessage(message);
    setOpen(true);
  };

  const createNew = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setSelectedMessage(undefined);
  };

  return (
    <ConversationContext.Provider value={{ updateMessage }}>
      {children({ containerRef, createNew })}
      <IonModal
        isOpen={isOpen}
        canDismiss={true}
        presentingElement={containerRef.current}
        onDidDismiss={onClose}
      >
        <ConversationModal
          chatId={id}
          messageId={selectedMessage?.id}
          onClose={onClose}
          isPresented={isOpen}
        />
      </IonModal>
    </ConversationContext.Provider>
  );
};

export { ConversationModalProvider };
